import { Injectable } from '@angular/core';
import { QarepaAuthStorage } from '@qarepa/common';
import { OAuth } from '../types/o-auth';

@Injectable({
  providedIn: 'root',
})
export class OAuthStorageService extends QarepaAuthStorage<OAuth> {
  protected key = 'oAuth';

  get isAuth(): boolean {
    const oAuth = this.get();
    return !!(oAuth?.access_token && oAuth.userId);
  }

  get token(): string {
    const oAuth = this.get();
    return oAuth?.access_token ?? '';
  }

  get userID(): number {
    const oAuth = this.get();
    return oAuth?.userId ?? 0;
  }
}
